import React from 'react';
import images from '../assets/images';
import { CInputPropTypes } from '../typedef/cinput.types';
import '../styles/cunderline.adaptive.input.styles.css';

const CUnderlineAdaptiveInput = ({
  inputId,
  input,
  setInput,
  type,
  label,
  error: { onError, errorMessage },
  inputRef,
  onFocused,
  onBlured,
  onDeleteInputClicked = () => {},
  disabled = false,
  isRequired,
  placeholder,
  isFocused,
}: CInputPropTypes) => {
  return (
    <div className='cunderline-adaptive-root'>
      <label htmlFor={inputId} hidden className='cunderline-adaptive-label'>
        <span className='cunderline-adaptive-label'>
          {label}
          {isRequired && (
            <span className='cunderline-adaptive-input-required'>*</span>
          )}
        </span>
      </label>
      <div className='cunderline-adaptive-input'>
        {disabled ? (
          <div className='cunderline-adaptive-disabled-input'>{input}</div>
        ) : (
          <>
            <input
              id={inputId}
              onFocus={onFocused}
              onBlur={onBlured}
              className='cunderline-adaptive-input-input'
              ref={inputRef}
              type={type}
              onChange={(e) => setInput(e.target.value)}
              placeholder={''}
            />
            {input !== '' && (
              <button
                className='cunderline-adaptive-delete-btn'
                onClick={onDeleteInputClicked}>
                <img
                  src={images.deleteBtn}
                  alt={`delete input btn of ${inputId}`}
                />
              </button>
            )}
            <div className='cunderline-adaptive-label'>
              <span
                className={`cunderline-adaptive-label ${
                  input !== '' || isFocused ? 'active' : 'deactive'
                }`}>
                {label}
                {isRequired && (
                  <span className='cunderline-adaptive-input-required'>*</span>
                )}
              </span>
            </div>
          </>
        )}
      </div>
      {!disabled && onError && (
        <div className='cunderline-adaptive-error-message'>{errorMessage}</div>
      )}
    </div>
  );
};

export default CUnderlineAdaptiveInput;
